<template>
  <v-app-bar 
    absolute app flat fixed
    class="transparent" 
    width="100%"
    height="150"
  >
    <v-row
      class=""
      :class="{
        'pr-10 justify-right text-right align-center': $vuetify.breakpoint.mdAndUp,
        'mx-auto': $vuetify.breakpoint.smAndDown
      }"
    >
      <v-col cols="12" md="6" class="justify-center text-center">
        <v-img
          contain
          :src="getImg(logo)"
          height='150'
          max-width='300'
          :class="{
            'mx-auto': $vuetify.breakpoint.smAndDown
          }"
        />
      </v-col>
      <v-col cols="12" md="6"
        v-if="$vuetify.breakpoint.mdAndUp"
        :class="{
          'pr-12 justify-end': $vuetify.breakpoint.mdAndUp,
          'justify-center': $vuetify.breakpoint.smAndDown
        }"
      >
        <v-row class="justify-end">
          <v-col cols="auto" class="pt-10">
            <hbt-contador :endtime="endtime" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-app-bar>
</template>

<script>
import HbtContador from '../components/Contador.vue'

export default {
  props: ['endtime'],
  components: {
    HbtContador
  },
  data: () => ({
    logo: 'logo.png',
  }),
  methods: {
    getImg(i) {
      return require('../assets/img/'+i)
    },
  },
}
</script>